import { TextDisclosure } from '@fcamna/react-library';
import Disclosure from '../../ui/Disclosure';
import { TDisclosureContainerAemProp } from '../../model/AemDataProps';
import { Section } from '../../ui/Section';

export default function DisclosureContainer({
  aemDisclosureContainerProp,
  featureDisclosureItems,
}: {
  aemDisclosureContainerProp: TDisclosureContainerAemProp;
  featureDisclosureItems?: any;
}) {
  const disclosureHeading = aemDisclosureContainerProp.headline;
  // should display either common disclosures or feature specific disclosure are present
  const shouldDisplayDisclosures =
    !!aemDisclosureContainerProp.disclosures || !!featureDisclosureItems;

  return shouldDisplayDisclosures ? (
    <div className={'disclosure'}>
      <Section
        titleProp={{
          title: disclosureHeading,
          headingLevel: 'h6',
          size: 'medium',
        }}
        id={'disclosure'}
        className={'mg-t-l'}
      />
      {aemDisclosureContainerProp.disclosures?.map((disc) => (
        <Disclosure
          key={disc.disclosure.disclosureKey}
          aemDisclosureProp={{ ...disc }}
          className={'global-disclosure'}
        />
      ))}
      {featureDisclosureItems && (
        <div>
          <TextDisclosure titleProp={{}} disclosureItems={featureDisclosureItems} />
        </div>
      )}
    </div>
  ) : null;
}
